import { render } from "./BellIcon.vue?vue&type=template&id=1638eb76&scoped=true"
import script from "./BellIcon.vue?vue&type=script&lang=js"
export * from "./BellIcon.vue?vue&type=script&lang=js"

import "./BellIcon.vue?vue&type=style&index=0&id=1638eb76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1638eb76"]])

export default __exports__